import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

import { firebaseConfig1, firebaseConfig2} from './config.js'

firebase.initializeApp(firebaseConfig1)
var firebase2 = firebase.initializeApp(firebaseConfig2, 'secondary');

 export {firebase, firebase2};